module.exports = __webpack_public_path__ + "static/media/PANO_20150814_174747.302b6fc0.jpg";